export default function SignupHeader({
  showAdminContent,
  userIsInactive
}: {
  showAdminContent: boolean;
  userIsInactive: boolean;
}) {
  return (
    <>
      <h1 className="mb-4 text-center d-flex justify-content-center">
        <div className="mb-2">
          Start putting vacation days back on your calendar.
        </div>
      </h1>
      {!showAdminContent && <h3 className="mb-5 text-center">{`Ask your firm admin to ${userIsInactive ? 'reactivate your account' : 'sign up'} today to continue maximizing your productivity.`}</h3>}
    </>
  );
}
